export default __webpack_public_path__ + "static/media/coin.3d.bfad6e3c.png";